/**
 * Firebase web config. These values are NOT secrets (they ship in every web client), but they are
 * per-project, so they live in .env.local instead of the repository. See .env.example.
 *
 * Security is enforced by Firestore Security Rules, never by this file.
 */
type FirebaseEnv = {
  apiKey: string
  authDomain: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}

const REQUIRED_KEYS = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
] as const

/** Missing variables are reported as a list, so one restart fixes all of them. */
export function readFirebaseEnv(): { config: FirebaseEnv | null; missing: string[] } {
  const env = import.meta.env as unknown as Record<string, string | undefined>
  const missing = REQUIRED_KEYS.filter((key) => !env[key]?.trim())
  if (missing.length > 0) return { config: null, missing }

  return {
    config: {
      apiKey: env.VITE_FIREBASE_API_KEY!,
      authDomain: env.VITE_FIREBASE_AUTH_DOMAIN!,
      projectId: env.VITE_FIREBASE_PROJECT_ID!,
      storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET!,
      messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID!,
      appId: env.VITE_FIREBASE_APP_ID!,
    },
    missing: [],
  }
}
